import type { RefObject } from 'react';
import React from 'react';

export interface ButtonProps extends React.HTMLProps<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  theme?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'custom'
    | 'wlp'
    | 'calorie'
    | 'muscle'
    | 'tofu'
    | 'quaternary'
    | 'quinary'
    | 'senary'
    | 'septenary'
    | 'mealPlan'
    | 'disabled'
    | 'blueBerryTransparent'
    | 'red'
    | 'transparent'
    | 'red'
    | 'orderFreq'
    | 'link'
    | undefined;
  link?: string;
  typeFormId?: string;
  ref?:
    | RefObject<HTMLButtonElement>
    | ((instance: HTMLButtonElement | null) => void)
    | null
    | undefined;
}

type Themes = {
  primary: string;
  secondary: string;
  tertiary: string;
  custom: string;
  wlp: string;
  calorie: string;
  muscle: string;
  quaternary: string;
  quinary: string;
  mealPlan: string;
  disabled: string;
  senary: string;
  septenary: string;
  red: string;
  orderFreq: string;
  blueBerryTransparent: string;
  [key: string]: string;
};

const themes: Themes = {
  primary:
    'text-white cursor-pointer bg-gradient-to-r from-primary to-primary2 hover:from-primary hover:to-primary',
  secondary: 'bg-secondary hover:bg-secondary2 text-rhubarb cursor-pointer',
  tertiary:
    'hover:hover:bg-marble text-black border border-black cursor-pointer',
  custom: 'bg-plan-custom text-black cursor-pointer',
  wlp: 'bg-plan-wlp text-black cursor-pointer',
  calorie: 'bg-plan-calorie text-black cursor-pointer',
  muscle: 'bg-plan-muscle text-black cursor-pointer',
  disabled: 'cursor-not-allowed bg-grey text-grey-dark',
  tofu: 'rounded-32 bg-tofu-dark',
  quaternary: 'text-black cursor-pointer',
  quinary:
    'text-black cursor-pointer bg-white border border-chef-lite hover:text-chef-red hover:bg-[#F7EEEB] active:text-black active:border-black active:bg-white',
  senary:
    'text-black cursor-pointer bg-white hover:text-chef-lite hover:bg-[#F7EEEB] active:text-black active:bg-white',
  septenary:
    'text-white cursor-pointer bg-black hover:bg-gradient-to-r hover:from-black hover:to-[#383838] active:to-black',
  mealPlan: 'bg-black text-white cursor-pointer',
  red: 'bg-primary text-white',
  blueBerryTransparent: 'bg-white text-blueberry cursor-pointer',
  transparent: 'bg-transparent text-white cursor-pointer',
  link: 'text-attention cursor-pointer',
  orderFreq:
    'text-black border border-black cursor-pointer hover:text-chef-red hover:bg-white active:text-black active:bg-white',
};

const baseStyle =
  'rounded-full px-4 py-2 text-base font-interMedium flex items-center justify-center min-w-32';

type BaseButtonProps = Omit<ButtonProps, 'link'>;

const TypeFormButton: React.FC<BaseButtonProps> = ({
  className,
  children,
  theme = 'primary',
  disabled = false,
}) => {
  const themeClass = disabled ? themes.disabled : themes[theme];
  const buttonClass = `${baseStyle} ${themeClass} ${className}`;

  return <div className={buttonClass}>{children}</div>;
};

export default TypeFormButton;
